import React from 'react';

export const IconArrow = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_16496_908)'>
      <path
        d='M0.22705 6.54961L5.44893 11.7715C5.75361 12.0762 6.2458 12.0762 6.54814 11.7715L11.7724 6.54961C12.0771 6.24492 12.0747 5.75274 11.7724 5.44805C11.47 5.14336 10.9755 5.1457 10.6708 5.44805L6.77783 9.34102L6.77783 0.77461C6.77783 0.345704 6.42861 -0.00351373 5.99971 -0.00351377C5.5708 -0.0035138 5.22158 0.345704 5.22158 0.77461L5.22158 9.34336L1.32861 5.45039C1.01924 5.15273 0.52705 5.15977 0.229394 5.46914C-0.0635752 5.76914 -0.0635743 6.24726 0.22705 6.54961Z'
        fill='#FF2D38'
      />
    </g>
    <defs>
      <clipPath id='clip0_16496_908'>
        <rect
          width='12'
          height='12'
          fill='white'
          transform='translate(12 12) rotate(-180)'
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconArrow;
